import { devLogger, exception, Exception } from "@xlabmedical/medic-web-framework";
import { ResponseStatusEnum } from "@xlabmedical/medic-api";

export const useOrderStore = defineStore("orderStore", {
    state: () => ({}),
    actions: {
        async acceptPrescriptionRevision(productionCenterId: number, pId: number, pfId: number) {
            try {
                await this.api.acceptPrescriptionRevision(productionCenterId, pId, pfId);

                return ResponseStatusEnum.OK;
            } catch (err) {
                exception("Error while accepting revision", err as Exception);
                devLogger.log("Error while accepting revision", err as Exception);

                return err;
            }
        },
    },
});
